import { adminDoPostLogin } from "services/admin/admin";
import { resetStore, useStore } from "stores/store";
import { adminDoGetProfile } from "services/admin/profile";
import { doGetUser } from "services/user/user";

export const logout = async () => {
  // clear storage
  resetStore();
};

export const loginAdmin = async (email: string, password: string) => {
  // do login
  const response = await adminDoPostLogin(email, password);

  // first clear all
  resetStore();

  // set data to store
  const { accessToken, refreshToken } = response;
  useStore.setState((state) => ({
    ...state,
    authenticated: true,
    accessToken,
    refreshToken,
  }));

  // get profile
  await fetchAuthAdmin();
};

export const loginAdminSignicat = async (
  accessToken: string,
  refreshToken: string,
) => {
  // first clear all
  resetStore();

  // set data to store
  useStore.setState((state) => ({
    ...state,
    authenticated: true,
    accessToken,
    refreshToken,
  }));

  // get profile
  await fetchAuthAdmin();
};

export const loginListUserSignicat = async (
  accessToken: string,
  refreshToken: string,
) => {
  // first clear all
  resetStore();

  // set data to store
  useStore.setState((state) => ({
    ...state,
    authenticated: true,
    accessToken,
    refreshToken,
  }));

  await fetchAuthUser();
};

export const fetchAuthAdmin = async () => {
  const authAdmin = await adminDoGetProfile();
  useStore.setState((state) => ({
    ...state,
    authAdmin,
    locale: authAdmin.locale,
  }));
};

export const fetchAuthUser = async () => {
  const authListUser = await doGetUser();
  useStore.setState((state) => ({
    ...state,
    authListUser,
    locale: authListUser.locale,
  }));
};
